'use strict';
const _ = require('lodash');
const $ = require('jquery');
const Backbone = require('backbone');
const ViewTopCta = require('./vote-cta');
const ViewFooter = require('./footer');
const ViewProgress = require('./progress');
const ViewGrid = require('./grid');
const template = require('../templates/home.ejs');

module.exports = Backbone.View.extend({
    className: 'view-home',
    events: { },
    /**
     *
     */
    initialize: function (options) {
        _.bindAll(this, 'render');

        this.ctaView = new ViewTopCta({
            model: this.model.header,
            turbo: this.model.turbo,
            modelTimerClosed: this.model.timerClosed,
            uid: options.uid
        });

        this.progressView = new ViewProgress({
            model: this.model.progress,
            css: options.css,
            uid: options.uid,
            cms: options.cms
        });

        this.gridView = new ViewGrid({
            model: this.model.grid,
            cms: options.cms,
            css: options.css,
            uid: options.uid
        });

        this.footerView = new ViewFooter({
            model: this.model.footer,
            modelTimer: this.model.timer,
            uid: options.uid
        });


        // THIS PORTION WAS USED TO DETERMINE IF WE WERE IN THE NATIVE WRAPPER
        // IF SO, ON RENDEREDTODOM FUNCTION WE ADDED A CLASS TO HANDLE HIDDING
        // DIFFERENT OPTIONS FOR LOGGING IN AND SHARING
        this.native = options.native;
    },
    /**
     *
     */
    render: function () {
        this.$el.html(template());

        this.$el.addClass((top === self ? 'frame-false' : 'frame-true') + ((!("ontouchstart" in document.documentElement) || !("ontouchstart" in window)) ? ' no-touch' : ' touch'))

        this.$('.cta-container').append(this.ctaView.$el);
        this.$('div[role="main"]').append(this.gridView.$el);
        this.$('footer').append(this.footerView.$el);
        this.$('.vote-progress').append(this.progressView.$el);

        return this;
    },
    /**
     * [renderedToDom description]
     * @return {[type]} [description]
     */
    renderedToDom: function() {
        // once the DOM is fully rendered, display the various views
        this.ctaView.render();
        this.ctaView.renderedToDom();

        this.progressView.render();
        this.progressView.renderedToDom();

        this.gridView.render();
        this.gridView.renderedToDom();

        this.footerView.render();
        this.footerView.renderedToDom();

        if(this.native) {
            this.$el.addClass('native');
        }
    },
    /**
     * remove
     */
    remove: function() {

        this.ctaView.remove();
        this.progressView.remove();
        this.gridView.remove();
        this.footerView.remove();

        Backbone.View.prototype.remove.call( this );
    }
});



// WEBPACK FOOTER //
// ./app/scripts/views/home.js